export default __webpack_public_path__ + "static/media/avatar_pyper7.c38a9c92.mp3";